<template>
    <router-view
    ></router-view>
</template>

<script>
export default {
name: "SkupDodatniSadrzajBase",
    methods:{
    }
}
</script>

<style scoped>

</style>